export default {
  meta: {
    title: '行业研报'
  }
};
